var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.514 20 20 15.5139 20 9.99994C20 4.48594 15.514 0 10 0C4.486 0 0 4.48594 0 9.99994C0 15.5139 4.486 20 10 20ZM10 1.81818C14.5115 1.81818 18.1818 5.48848 18.1818 9.99994C18.1818 14.5114 14.5115 18.1818 10 18.1818C5.48848 18.1818 1.81818 14.5114 1.81818 9.99994C1.81818 5.48848 5.48854 1.81818 10 1.81818Z",
    fill: "#FF4004"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0015 15.7578C10.6697 15.7578 11.2134 15.2138 11.2134 14.5451C11.2134 13.8771 10.6697 13.3336 10.0015 13.3336C9.33326 13.3336 8.78962 13.8771 8.78962 14.5451C8.78962 15.2138 9.33326 15.7578 10.0015 15.7578Z",
    fill: "#FF4004"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 11.5151C10.5021 11.5151 10.9092 11.1081 10.9092 10.606V5.1515C10.9092 4.64944 10.5021 4.24241 10.0001 4.24241C9.49803 4.24241 9.091 4.64944 9.091 5.1515V10.606C9.091 11.1081 9.49803 11.5151 10.0001 11.5151Z",
    fill: "#FF4004"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.309d5d4cf0986336e6d3b0d495bea6c7.svg";
export { ForwardRef as ReactComponent };